<template>
  <div class="gostart">
    <div class="wrap">
      <div class="gostart-text">
        <div class="title">熊猫快启</div>
        <div class="tips">一站式解决系统桌面杂乱问题</div>
      </div>
      <div class="download">
        <a
          class="left"
          href="https://info.xmgjx.cn/storage/gostartin.zip"
          target="_blank"
        ></a>
        <a
          class="right"
          href="https://info.xmgjx.cn/storage/gostart.zip"
          target="_blank"
        ></a>
      </div>
      <div class="card">
        <div class="card-item"></div>
        <div class="card-item card-item2"></div>
        <div class="card-item card-item3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoStart",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/views/goStart/index.vue